/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tld_Pricing_Empty_DescriptionInputs */

const id_tld_pricing_empty_description = /** @type {(inputs: Tld_Pricing_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambahkan TLD yang dijual untuk mengatur harganya.`)
};

const en_tld_pricing_empty_description = /** @type {(inputs: Tld_Pricing_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a TLD the portal sells to set its pricing.`)
};

/**
* | output |
* | --- |
* | "Add a TLD the portal sells to set its pricing." |
*
* @param {Tld_Pricing_Empty_DescriptionInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_empty_description = /** @type {((inputs?: Tld_Pricing_Empty_DescriptionInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Empty_DescriptionInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_empty_description(inputs)
	return id_tld_pricing_empty_description(inputs)
});